import * as actionTypes from "../consts/actionTypes";

export function getCommunication() {
    return {
      type: actionTypes.GET_COMMUNICATION,
      payload: "",
    }
  }


  export function getAllCommunications(id) {
      return {
          type: actionTypes.GET_ALL_COMMUNICATION,
          payload: id
      };
  }

  export function updateAllCommunication(communications) {
      return {
          type: actionTypes.GET_UPDATE_ALL_COMMUNICATION,
          payload: communications
      };
  }

  
  export function modifyCommunication(param) {
      return {
          type: actionTypes.MODIFY_COMMUNICATION,
          payload: param
      };
  }

  export function selectCommunication(communicationSelected) {
      return {
          type: actionTypes.SELECT_COMMUNICATION,
          payload: communicationSelected
      };
  }
  

  export function setCommunication(param) {
      return {
          type: actionTypes.SET_COMMUNICATIONS,
          payload: param
      };
  }
  
  
  
  export function setCount(COUNT) {
      return {
          type: actionTypes.SET_COUNT_COMMUNICATION,
          payload: COUNT
      };
  }
  
  
  /**/ 
  
  
  export function removeModifyCommunication(param) {
      return {
          type: actionTypes.RESET_MODIFY_COMMUNICATION,
          payload: param
      };
  }
  
  export function getNotification(id) {
      return {
          type: actionTypes.GET_COMMUNICATION,
          payload: id
      };
  }
  
  export function setHashNotification(hash) {
      return {
          type: actionTypes.HASH_COMMUNICATION,
          payload: hash
      };
  }
  